import { render, staticRenderFns } from "./EpiProperty.vue?vue&type=template&id=5b8e3562&"
import script from "./EpiProperty.vue?vue&type=script&lang=js&"
export * from "./EpiProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8e3562')) {
      api.createRecord('5b8e3562', component.options)
    } else {
      api.reload('5b8e3562', component.options)
    }
    module.hot.accept("./EpiProperty.vue?vue&type=template&id=5b8e3562&", function () {
      api.rerender('5b8e3562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/EpiProperty.vue"
export default component.exports